type ClassName = string | false | undefined | null

/** @deprecated Use 'twMerge' from 'tailwind-merge' */
export function cx(...classNames: ClassName[]) {
  return classNames.filter(Boolean).join(' ')
}
